<!--
 * @Descripttion:
 * @Author: zsw
 * @Date: 2020-05-15 15:25:57
 -->
<template>
  <div>
    <div v-if="type === 'ppt'" class="toggle-wrapper">
      <div class="progress-wrapper">
        <span @click="toggleDisplayHandler">{{toggleDisplayControllText}}</span>
        <span>{{finishedNum}}/{{totalNum}}</span>
      </div>
      <el-progress class="progress-content" :percentage="finishedPercent" :stroke-width='12' :show-text='false' color="#68BF7B"></el-progress>
      <div class="checkout-wrapper" v-if="showUploadDisplayStyle === 'oneByOne'">
        <span @click="preHandler" :class="{'disabled': preDisabled }">返回上一课时</span>
        <span @click="nextHandler" :class="{'disabled': nextDisabled }">下一课时</span>
      </div>
    </div>
    <div class="file-list">
      <div
        :class="fileWrapperDisplayClassName"
        v-for="(materials, pIndex) in currentUploadFiles"
        :key="pIndex"
      >
        <div class="ppt-border">
          <div v-if="type === 'ppt'">
            <p class="course-title">第{{materials.index + 1}}课时</p>
            <div
              class="file-name-input file-font"
              v-if="shouldShowMaterialTitle"
              :title="materials.title"
            >{{ materials.title }}</div>
            <input
              v-else
              class="file-name-input"
              :placeholder="materials.placeholder"
              type="text"
              v-model="materials.title"
              @focus="inputFous($event, materials)"
              @blur='inputChange($event, materials)'
              @keyup.enter='inputChange($event, materials)'
            >
          </div>
          <div class="file-series">
            <div v-for="(file, index) in materials.files" :key="pIndex + '' + index" class="upload-view-container" :class="{'prevent-style': showMask(materials)}">
              <div class="upload-musk" v-if="file.updateObjectWhenMaterialRejected(hidenFileStatus ? '' : materials.auditStatus, materials.rejectedDate, materials.id).show==='approve'" @click="isUpload(file.id)"></div>
              <upload-view
                :ref="'refName'+file.id"
                :type='file.type'
                :fileDesc="desc"
                :tag="pIndex + '' + index"
                :deleteable="deleteVisible(materials, file)"
                :img='iconShow(file)'
                :icon='file.icon'
                :activeIcon='file.activeIcon'
                :index='index'
                :path='fileUrl(file)'
                :name='file.remoteFile.name'
                :activityId="activityId"
                :playerId="playerId"
                :couldDownload="!deleteVisible(materials, file) && canDownload"
                :changeObj="file.updateObjectWhenMaterialRejected(hidenFileStatus ? '' : materials.auditStatus, materials.rejectedDate, materials.id)"
                @uploadSucc='uploadSuccessHandler(arguments, file, materials, index)'
                @uploadDel="deleteFileHandler(file)"
                @deleteFile='() => clickRemove(file, pIndex, index, materials)'
                @download='() => downloadAttachment(file)'
              >
              </upload-view>
            </div>
            <div class="mask" v-if="showMask(materials)">
              <span v-show="!materials.title">请先填写教学设计标题</span>
              <span v-show="materials.title">输入回车保存标题</span>
            </div>
          </div>
          <!-- 驳回原因 -->
          <div v-if="showRejetedTxt(materials)" class="audit-content" v-html="materials.auditContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadImage from '@/components/MaterialUploadBt'
import UploadView from '@/components/upload-view'
import auditStatus from '@/model/auditStatus'
import { descriptionIsVideo } from '../model/processingData'
import { postMaterialV3, putMaterialV3 } from '@/service/uploadFile'

export default {
  components: {
    UploadImage,
    UploadView
  },
  name: 'FileUploader',
  props: {
    type: {
      type: String
    },
    value: {
      type: Array
    },
    status: {
      type: String
    },
    canDownload: {
      type: Boolean,
      default: false
    },
    activityId: {
      type: Number | String
    },
    playerId: {
      type: Number | String
    },
    attachmentId: {
      type: Number | String,
      default: ''
    },
    typesItemIndex: {
      type: Number,
      default: 0
    },
    fileDesc: { // 教学反思，教学视频描述
      type: String
    },
    rejectFileIdList: { // 驳回文件id列表
      type: Array
    },
    hidenFileStatus: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    isUploadingMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      fileList: [],
      desc: '',
      itemMinWidth: 212,
      fileItemWidth: 212,
      updateFileTagList: '', // 已更新upload tag 列表
      showUploadDisplayStyle: 'all',
      currentUploadFileIndex: 0,
      inputSave: '' // 输入框缓存发生变化才调接口
    }
  },
  mounted () {
    // 刷新找到第一个未上传的index
    const currentIndex = this.fileList.findIndex(item => !this.fileIsUploadSuccess(item))
    this.currentUploadFileIndex = currentIndex > -1 ? currentIndex : 0
    let screenWidth = document.body.clientWidth
    this.fileItemWidth = (screenWidth - 50) / 6 - 20
    if (this.fileItemWidth < this.itemMinWidth) {
      this.fileItemWidth = this.itemMinWidth
    }
    window.addEventListener('resize', () => {
      this.fileItemWidth = (screenWidth - 50) / 6 - 20
      if (this.fileItemWidth < this.itemMinWidth) {
        this.fileItemWidth = this.itemMinWidth
      }
    }, false)
    this.fileList = this.value
    this.desc = this.fileDesc
    setTimeout(() => {
      const linesELes = document.getElementsByClassName('file-wrapper')
      for (let i = 0; i < linesELes.length; i++) {
        if (linesELes[i].offsetLeft < 50) {
          let lineNode = linesELes[i].getElementsByClassName('line-right')[0]
          lineNode.style.display = 'none'
        }
      }
    }, 0)
  },
  computed: {
    showMask () {
      return (materials) => {
        if (!this.isUploadingMode) {
          return false
        }
        if (!materials || !materials.files) {
          return false
        }
        const includePptFile = materials.files.some(file => file.type === 'ppt')
        return includePptFile && !materials.id
      }
    },
    shouldShowMaterialTitle () {
      return this.type === 'word' || this.status === 'pending' || this.status === 'approved'
    },
    deleteVisible () {
      return (materials, file) => {
        if (materials.auditStatus === auditStatus.UNCOMMITTED) {
          return file && file.remoteFile && file.remoteFile.path
        } else if (materials.auditStatus === auditStatus.REFUSED || materials.auditStatus === auditStatus.REJECTED) {
          return file && file.remoteFile && file.remoteFile.path
        } else if (materials.auditStatus === '') {
          return file && file.remoteFile && file.remoteFile.path
        } else {
          return false
        }
      }
    },
    showRejetedTxt () {
      return materials => materials.auditContent && (this.status !== 'pending' && this.status !== 'approved')
    },
    fileWrapperDisplayClassName () {
      if (this.type !== 'ppt') {
        return 'files-wrapper-large'
      } else {
        if (this.showUploadDisplayStyle === 'all') {
          return 'files-wrapper'
        } else {
          return 'files-wrapper-large'
        }
      }
    },
    finishedNum () {
      const finishedTotle = this.fileList.reduce((cur, next) => {
        const hasFinished = this.fileIsUploadSuccess(next)
        if (!hasFinished) {
          return cur + 0
        } else {
          return cur + 1
        }
      }, 0)
      return finishedTotle
    },
    totalNum () {
      return this.fileList.length
    },
    finishedPercent () {
      if (!this.totalNum) {
        return 0
      }
      return Math.floor(this.finishedNum * 100 / this.totalNum)
    },
    toggleDisplayControllText () {
      return this.showUploadDisplayStyle === 'all' ? '展示单独课时' : '展示所有课时'
    },
    currentUploadFiles () {
      if (this.showUploadDisplayStyle === 'all') {
        let { fileList } = this
        if (fileList && fileList.length === 1 && fileList[0].files.length === 1) {
          let copyFileList = JSON.parse(JSON.stringify(fileList))
          let str = (copyFileList[0].files[0].type + ',' + 'pdf').split(',')
          let strArr = [...(new Set(str))]
          fileList[0].files[0].type = strArr.join(',')
          return fileList
        }
        return this.fileList
      }
      const item = this.fileList[this.currentUploadFileIndex]
      return [item]
    },
    preDisabled () {
      return this.currentUploadFileIndex <= 0
    },
    nextDisabled () {
      return !this.fileIsUploadSuccess(this.currentUploadFiles[0]) || this.currentUploadFileIndex >= this.totalNum - 1
    }
  },
  watch: {
    value (val) {
      this.fileList = this.value
    },
    fileDesc (val) {
      this.desc = val
    },
    attachmentId (val) {
    }
  },
  methods: {
    nextHandler () {
      if (this.nextDisabled) {
        return
      }
      this.currentUploadFileIndex += 1
    },
    preHandler () {
      if (this.preDisabled) {
        return
      }
      this.currentUploadFileIndex -= 1
    },
    fileIsUploadSuccess (file) {
      if (!file || file.title === '' || !file.files) {
        return false
      }
      if (file.files.some(item => !item.remoteFile || item.remoteFile.path === '')) {
        return false
      }
      return true
    },
    toggleDisplayHandler () {
      if (this.showUploadDisplayStyle === 'all') {
        this.showUploadDisplayStyle = 'oneByOne'
        return
      }
      this.showUploadDisplayStyle = 'all'
    },
    // 上传按钮是否可见
    uploadVisible (file) {
      if (!file || !file.remoteFile || !file.remoteFile.path) {
        return true
      }
      return false
    },
    getFileName (file) {
      if (file && file.remoteFile && file.remoteFile.name) {
        return file.remoteFile.name
      } else {
        if (this.type === 'ppt') {
          if (file.type === 'ppt') {
            return '请上传PPT文件'
          } else if (file.type === 'pdf') {
            return '请上传PDF文件'
          }
        } else if (this.fileDesc && descriptionIsVideo(this.fileDesc)) { // 教学视频文件格式
          return '请上传视频文件'
        }
        return '请上传word文件'
      }
    },
    getFileNameStyle (file, padding, id, tag) {
      let uploadBtWidth = 50
      if (file && file.remoteFile && file.remoteFile.name) {
        uploadBtWidth = 0
        if (this.getFileReviewStatusClass(id, tag)) {
          uploadBtWidth = 45
        }
      }
      return { 'max-width': (this.fileItemWidth - padding - uploadBtWidth) + 'px' }
    },
    clickRemove (file, pIndex, index, material) {
      this.deleteAttachment(file, pIndex, index, material)
    },
    // 删除已经上传的文件
    deleteAttachment (file, pIndex, index, material) {
      // eventBus.$emit('removeFile', tag)
      // this.deleteFileHandler(file)
      // let tag = pIndex + '' + index
      // if (!material.id) {
      //   eventBus.$emit('removeFile', tag)
      //   this.deleteFileHandler(file)
      //   return
      // }
      // this.$emit('deleteItem', this.typesItemIndex, pIndex, index, this.type)
      this.deleteFileHandler(file)
    },
    isInputEnable (materials, type) { // PPT被驳回 则输入框可以输入即返回false
      // 第一次提交材料或没有被驳回
      if (this.rejectFileIdList && this.rejectFileIdList.length <= 0) {
        return false
      }
      if (type === 'ppt' && this.rejectFileIdList && this.rejectFileIdList.length > 0 && this.rejectFileIdList.indexOf(String(materials.id)) !== -1) {
        return false
      }
      return true
    },
    iconShow (file) {
      let icon
      if (file.remoteFile.path) {
        icon = file.activeIcon
      } else {
        icon = file.icon
      }
      return icon
    },
    fileUrl (file) {
      let path
      if (file.remoteFile.path) {
        path = file.remoteFile.host + file.remoteFile.path
      } else {
        path = ''
      }
      return path
    },
    canDelete (id) {
      if (!this.rejectFileIdList || this.rejectFileIdList.length === 0) {
        return false
      }
      return this.rejectFileIdList.indexOf(String(id)) !== -1
    },
    getFileReviewStatusClass (id, tag) {
      if (this.status === auditStatus.REFUSED) { // 只有在审核拒绝的情况下才会显示已拒绝或已更新
        if (this.updateFileTagList && this.updateFileTagList.indexOf(tag) !== -1) {
          return 'updated'
        } else if (this.rejectFileIdList && this.rejectFileIdList.length > 0 && this.rejectFileIdList.indexOf(String(id)) !== -1) {
          return 'refused'
        }
      }
      return ''
    },
    uploadSuccessHandler (children, file, feild, index) {
      console.log(feild)
      let info = [...children]
      file.remoteFile.path = info[0]
      file.remoteFile.name = info[1]
      file.remoteFile.host = info[2]
      file.remoteFile.size = info[3]
      console.log(file)
      console.log(index)
      this.sendDataToServer(feild, index, file)
    },
    sendDataToServer (feild, index, fileHold) {
      console.log(fileHold)
      console.log(feild)
      const params = {
        file_sort: feild.index,
        title: feild.title || ''
      }
      params.resources = feild.files.map(file => {
        return {
          category: file.type === 'mp4' ? 'word' : file.type,
          url: file.remoteFile.path,
          size: file.remoteFile.size,
          title: file.remoteFile.name
        }
      }).filter(item => item.url !== '')
      if (params && params.resources) {
        for (let item of params.resources) {
          let arr = (item.category).split(',')
          if (arr.length > 1) {
            if (arr.filter(v => (item.title.indexOf(v)) > -1).length > 0) {
              item.category = arr.filter(v => (item.title.indexOf(v)) > -1)[0]
            } else {
              item.category = 'word'
            }
          }
        }
      }
      if (!feild.id) {
        postMaterialV3(this.activityId, this.attachmentId, params).then(res => {
          if (res.status !== 'success') {
            this.$message({ type: 'error', message: res.msg })
            fileHold.remoteFile.path = ''
            fileHold.remoteFile.name = ''
            fileHold.remoteFile.host = ''
            fileHold.remoteFile.size = 0
            return
          }
          feild.id = res.data.id
        })
      } else {
        putMaterialV3(this.activityId, this.attachmentId, feild.id, params).then(res => {
          if (res.status !== 'success') {
            this.$message({ type: 'error', message: res.msg })
            return
          }
          if (!fileHold) {
            return
          }
          const resources = (res && res.data && res.data.resources) ? res.data.resources : []
          const categoryKey = fileHold.type === 'mp4' ? 'word' : fileHold.type
          const categoryCandidates = String(categoryKey).split(',').map(v => v.trim()).filter(Boolean)
          const updateResource = resources.find(resource => categoryCandidates.includes(resource.category))
          if (updateResource && updateResource.update_time) {
            fileHold.setUpdateDate(updateResource.update_time)
          }
          const refuseAndUpdateFiles = localStorage.getItem('refuseAndUpdateFiles') ? JSON.parse(localStorage.getItem('refuseAndUpdateFiles')) : []
          if (!refuseAndUpdateFiles.includes(`${feild.id}-${fileHold.type}`)) {
            refuseAndUpdateFiles.push(`${feild.id}-${fileHold.type}`)
            localStorage.setItem('refuseAndUpdateFiles', JSON.stringify(refuseAndUpdateFiles))
          }
          // 拒绝驳回状态
          if (index !== undefined) {
            const tag = feild.id + '' + index
            if (!this.updateFileTagList || this.updateFileTagList.indexOf(tag) === -1) {
              this.updateFileTagList += (tag + ',')
            }
          }
        })
      }
    },
    inputChange (e, feild) {
      if (this.inputSave === feild.title) {
        return
      }
      if (feild.title) {
        this.sendDataToServer(feild)
      }
    },
    inputFous (e, feild) {
      this.inputSave = feild.title
    },
    deleteFileHandler (file) {
      file.remoteFile.path = ''
      file.remoteFile.name = ''
      file.remoteFile.host = ''
      file.remoteFile.size = ''
    },
    downloadAttachment (file) {
      this.$emit('downloadAttachment', file.type, file.remoteFile.host + file.remoteFile.path, file.remoteFile)
    },
    async isUpload (id) {
      this.$message({
        message: '此附件已通过审核不可替换',
        type: 'warning'
      })
      // let res = await this.$confirm('此附件已通过审核, 是否替换?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      // if (res) {
      //   let ref = eval('this.$refs.refName' + (id))[0]       // eslint-disable-line
      //   // let ref = this.eval2('this.$refs.refName' + (id))
      //   ref.$refs.upload.$refs['upload-inner'].handleClick()
      // }
    }
    // eval2(fn) {
    //   var Fun = Function // 一个变量指向Function，防止有些前端编译工具报错
    //   console.log(fn);
    //   return new Fun('return ' + fn)()
    // }
  }
}
</script>
<style lang="scss" scoped>
.file-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.files-wrapper {
  width: 48%;
}

.files-wrapper-large {
  width: 100%;
  margin-top: 20px;
}

.files-wrapper:last-child {
  margin-right: 0;
}
.file-wrapper {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 10px;
  .file {
    width: 106px;
  }
  .file:first-child {
    margin-left: 0;
  }
  .line-right {
    display: inline-block;
    position: absolute;
    left: -12px;
    top: 0;
    width: 3px;
    height: 100px;
    background-color: #ececec;
    border-radius: 2px;
  }
  &:first-child .line-right {
    display: none;
  }
}
.file-font {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.file-name-input {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-bottom: 24px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  font-size: 16px;
  padding: 0 12px;
  box-sizing: border-box;
  color: #4E5A73;
  font-weight: normal;
  outline: none;
  &:active {
    border-color: #DCDFE6;
  }
  &:focus {
    border-color: #DCDFE6;
  }
}

input::-webkit-input-placeholder {
  font-size: 16px;
  color: #DCDFE6;
}
input:-moz-placeholder {
  font-size: 14px;
  color: #DCDFE6;
  font-weight: 400;
}
input::-moz-placeholder {
  font-size: 14px;
  color: #DCDFE6;
  font-weight: 400;
}
input:-ms-input-placeholder {
  font-size: 14px;
  color: #DCDFE6;
  font-weight: 400;
}
.stage-index {
  width: 227px;
  margin: 0px;
}
.download-btn {
  width: 50px;
  height: 20px;
  padding: 0;
}

.ppt-border {
}
.item-bg {
  position: relative;
  margin-left: 5px;
  margin-top: 5px;
  // height: 60px;
  text-overflow: ellipsis;
  // overflow: hidden;
  white-space: nowrap;
  .bg {
    height: 58px;
    left: 5px;
    padding-left: 50px;
    background: rgba(249, 249, 249, 1);
    border-radius: 3px;
    border: 1px solid rgba(236, 236, 236, 1);
  }
  .file-icon {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 5px;
    left: -5px;
  }
  .file-name {
    display: block;
    margin-top: 10px;
    // margin-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #606060;
  }
  .preview-bt {
    font-size: 12px;
    color: #4a90e2;
    margin-right: 10px;
  }
  .delete-bt {
    width: 30px;
    display: block;
    line-height: 15px;
    font-size: 12px;
    color: #c12b20;
    margin-right: 10px;
    cursor: pointer;
  }
  .upload-success-icon {
    position: absolute;
    width: 14px;
    height: 14px;
    top: 5px;
    right: 5px;
  }
  .review-bg {
    position: absolute;
    width: 41px;
    height: 15px;
    line-height: 15px;
    font-size: 9px;
    color: #ffffff;
    padding: 2px;
    text-align: center;
    border-radius: 8px;
    top: 23px;
    right: 20px;
  }
  .refused {
    background: rgba(231, 86, 86, 1);
  }
  .updated {
    background: rgba(81, 83, 133, 1);
  }
}
// new style
.course-title {
  font-size: 16px;
  font-weight: 600;
  color: #4E5A73;
  text-align: left;
  margin-bottom: 24px;
}

.toggle-wrapper {
  position: relative;
}

.progress-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 8px;
  span:first-child {
    font-size: 16px;
    color: #68BF7B;
    cursor: pointer;
  }
  span:last-child {
    font-size: 14px;
    color: #4E5A73;
  }
}

.progress-content {
  width: 100%;
}

.checkout-wrapper {
  position: absolute;
  right: 0px;
  bottom: -64px;
  z-index: 100;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #4E5A73;
  font-weight: bold;
  user-select: none;
  span {
    cursor: pointer;
  }
  span:last-child {
    margin-left: 26px;
  }
  .disabled {
    color: #BDC3D1;
    cursor: default;
  }
}

.audit-content {
  font-size: 12px;
  font-weight: 600;
  color: #F04037;
  line-height: 17px;
  text-align: left;
  padding: 0 10px;
  box-sizing: border-box;
  word-break: break-all;
}

.upload-view-container {
  position: relative;
  .upload-musk {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    z-index: 1;
  }
  &:nth-child(2n) {
    margin-bottom: 14px;
  }
}

.file-series {
  position: relative;
}

.mask {
  width: 100%;
  height: 100%;
  background: rgba(104,191,123, 0.9);
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: #fff;
    font-weight: bold;
  }
}
.prevent-style {
  filter: blur(5px);
}
</style>

<style>
.approved-text {
  color: rgb(104, 191, 123);
}
</style>



// WEBPACK FOOTER //
// src/components/MaterialUploader.vue